module.exports = "/src/views/player/help/images/street1.jpg";